module.exports = __webpack_public_path__ + "media/images/locations/muenchenstein-map-bca83578484d4187240abb5a36f073fb.jpg";